import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectWidget } from 'actions/application';

import cx from 'classnames';
import _ from 'lodash';

import { Dropdown, Image } from "react-bootstrap";

import CollectionWidgetManager from 'services/collections.widget.service';

import styles from './components.module.scss';

export default function Widgets({filter}) {
  const dispatch = useDispatch();
  const widgetManager = new CollectionWidgetManager();


  const assets = useSelector(state => _.get(state, `application.assets`, []));
  const collection = useSelector(state => _.get(state, `application.collection`, null));

  const widgets = widgetManager.widgets.map(widget => {
    return {
      id: widget.id,
      name: widget.name,
      description: widget.description,
      icon: widget.icon
    }
  }).filter((item) => {

    if(filter){
      return filter(item.id);
    }
    else if(_.size(assets) > 1){
      return item.id === "ASSETS_TABLE_WIDGET";
    }else{
      return true;
    }
  });

  const selectedWidget = useSelector((state) => {
    const id = _.get(state, 'application.widget');

    return widgets.find(widget => widget.id === id) || widgets[0];
  })

  const onChange = (widget) => {
    dispatch(selectWidget(widget));
  }

  return (
    <div className={styles.widgets}>
      <h4>Choose attachment type</h4>
      <Dropdown>
        <Dropdown.Toggle className={styles.selectedWidget}>
          <div className={cx(styles.widget, styles.selected)}>
            <Image src={selectedWidget.icon} />
            <div className={styles.details}>
              <div className={styles.name}>{selectedWidget.name}</div>
            </div>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu className={styles.dropdown}>
          {widgets.map(widget => {
            return (
              <Dropdown.Item key={widget.id} eventKey={widget.id} onSelect={() => onChange(widget)}>
                <div className={styles.widget}>
                  <div className={styles.details}>
                    <div className={styles.name}>{widget.name}</div>
                  </div>
                </div>
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
